const createSessionKey = ({ slug }) => `${slug}-state`

export default createSessionKey
